import { request } from "."

export const formApi = {
  getFormData(formId: string) {
    return request("/api/forms/"+formId)
  },
  getCheckList(teamId: string) {
    return request(`/api/teams/${teamId}/check-list`)
  },
  getAllCheckLists() {
    return request('/api/forms/stage-tasks')
  },
  sendForm(values: any) {
    return request("/api/reports", values)
  },
  sendFormEdit(reportId: string, values: any) {
    return request("/api/reports/"+reportId, values)
  },
  sendLimitForm(values: any) {
    return request("/api/limits", values)
  },
  sendLimitFormEdit(reportId: string, values: any) {
    return request("/api/limits/"+reportId, values)
  },

  sendSupervisorForm(values: any) {
    return request("/api/supervisor-reports", values)
  },
  editSupervisorForm(reportId: string, values: any) {
    return request("/api/supervisor-reports/"+reportId, values)
  },

  getLimitsMeta() {
    return request("/api/limits/meta")
  }
}